import React, { useCallback } from 'react';
import i18n from 'i18n';
import TabPanel from 'components/TabPanel';
import TabContent from './TabContent';
import { StyledContinueWatchingPage } from './StyledComponents';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

const ContinueWatchingPage = (props) => {
  const { items, fetchContinueWatching, loadExtraContinueWatchingItems, removeItem } = props;

  const onTabEnter = useCallback(
    ({ id }) => {
      const dashboardName = id === 'vod' ? 'CONTINUE_WATCHING' : 'RECENT_CHANNELS';

      innerAnalyticsVolia.postEvent({
        eventGroup: `dashboard: ${dashboardName}`,
        eventName: 'open dashboard',
      });

      fetchContinueWatching(id);
    },
    [fetchContinueWatching],
  );

  return (
    <StyledContinueWatchingPage>
      <TabPanel title={i18n.t('continueWatching.title')} onEnter={onTabEnter}>
        <TabPanel.Tab id="catchup" title={i18n.t('continueWatching.catchup.title')} path="catchup">
          <TabContent
            content={items.catchup}
            loadExtraItems={loadExtraContinueWatchingItems}
            removeItem={removeItem}
            emptyPlaceholder={i18n.t('continueWatching.catchup.emptyPlaceholder')}
            type="catchup"
          />
        </TabPanel.Tab>
        <TabPanel.Tab id="vod" title={i18n.t('continueWatching.vod.title')} path="vod">
          <TabContent
            content={items.vod}
            loadExtraItems={loadExtraContinueWatchingItems}
            removeItem={removeItem}
            emptyPlaceholder={i18n.t('continueWatching.vod.emptyPlaceholder')}
            type="vod"
          />
        </TabPanel.Tab>
        <TabPanel.Tab id="channel" title={i18n.t('continueWatching.channel.title')} path="channel">
          <TabContent
            content={items.channel}
            loadExtraItems={loadExtraContinueWatchingItems}
            removeItem={removeItem}
            emptyPlaceholder={i18n.t('continueWatching.channel.emptyPlaceholder')}
            type="channel"
          />
        </TabPanel.Tab>
      </TabPanel>
    </StyledContinueWatchingPage>
  );
};

// todo: props
ContinueWatchingPage.defaultProps = {
  items: {},
};

export default ContinueWatchingPage;
